module.exports = __webpack_public_path__ + "lp/img/mic_icn-darkgray.a4346be4.svg";